module.exports = __webpack_public_path__ + "796458b4a58004943b7b4a2c8882fc48.pdf";